<template>
  <el-select
    v-model="selectedState"
    @input="$emit('input', selectedState)"
    @change="$emit('change', selectedState)"
  >
    <el-option
      v-for="state in states"
      :key="state.id"
      :label="state.name"
      :value="state.id"
    ></el-option>
  </el-select>
</template>

<script>
import routingService from '@/api/routingService';

export default {
  name: 'StateSelect',
  props: {
    value: {
      type: [String, Number, null],
      default: null
    },
    includeOptionAll: {
      type: Boolean,
      default: false
    },
    allowedIds: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      selectedState: null,
      states: []
    };
  },
  mounted() {
    if (this.includeOptionAll) {
      this.states = [
        {
          id: null,
          name: this.$t('common.all')
        }
      ];
    }

    routingService.getStates().then((response) => {
      // Filtrar los estados por los IDs permitidos
      const filteredStates = response.data.filter(
        state => !this.allowedIds || this.allowedIds.includes(state.id)
      );

      // Mapear los estados filtrados
      this.states = this.states.concat(
        filteredStates.map(state => ({
          id: state.id,
          name: state.name.concat(' - ').concat(state.code)
        }))
      );
    });
  }
};
</script>
